module.exports = __webpack_public_path__ + "img/avatar_test.deb8ef70.png";